import type { ZudokuConfig } from "zudoku";
import LandingPage from "../src/LandingPage";
import ApiKeysPage from "../src/pages/ApiKeysPage";
import LoginPage from "../src/pages/LoginPage";

export const navigation: ZudokuConfig["navigation"] = [
	{
		type: "link",
		to: "/",
		label: "Home",
	},
	{
		type: "custom-page",
		path: "/",
		element: <LandingPage />,
	},
	{
		type: "category",
		label: "Documentation",
		items: [
			{
				type: "category",
				label: "Getting Started",
				icon: "sparkles",
				collapsed: false, 
				items: [
					"/introduction",
					"/developer-registration",
					"/api-security",
					"/api-usage",
				],
			},
			{
				type: "category",
				label: "The APIs",
				icon: "cable",
				collapsed: false, 
				items: [
					"/api-intro-mobility",
					"/api-intro-aviation",
					"/api-intro-marine",
				],
			},
		],
	},
	{
		type: "category",
		label: "Streaming API",
		items: [
			"/streaming",
			"/streaming-api-usage",
		],
	},
	{
		type: "link",
		to: "/mobility",
		label: "Mobility API",
	},
	{
		type: "link",
		to: "/aviation",
		label: "Aviation API",
	},
	{
		type: "link",
		to: "/marine",
		label: "Marine API",
	},
	{
		type: "custom-page",
		path: "/settings/api-keys",
		element: <ApiKeysPage />,
		display: "hide",
	},
	{
		type: "custom-page",
		path: "/login",
		element: <LoginPage />,
		display: "hide",
		layout: "none",
	},
];
